import dateFormat from 'vux/src/tools/date/format.js'

let dateformat = (value,format) => {
if(!format){
format = 'YYYY-MM-DD HH:mm:ss'
}
if(format.indexOf("YYYY") > -1){
return dateFormat(new Date(value), format)
}
else{
return dateFormat1(value, format)
}
}
let dateFormat1 = (str,fmt) => {
let date = new Date(str)
if (/(y+)/.test(fmt)) {
fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
}
let o = {
'M+': date.getMonth() + 1,
'd+': date.getDate(),
'h+': date.getHours(),
'm+': date.getMinutes(),
's+': date.getSeconds()
};
for (let k in o) {
if (new RegExp(`(${k})`).test(fmt)) {
let str = o[k] + '';
fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : ('00' + str).substr(str.length));
}
}
return fmt;
}

let faultRepair_orderState = value => {
let state = '受理中'
switch(value){
case 2:state = '处理中'; break;
case 3: state = '已完成'; break;
}
return state
}

let faultRepair_orderState_Class = value => {
let state = 'fault_order_state_wfl'
switch(value){
case 2:state = 'fault_order_state_dwc'; break;
case 3: state = 'fault_order_state_ywc'; break;
}
return state
}
import numberComma from 'vux/src/tools/number/comma.js'

let moneyFormat = value=>{
return numberComma(value)
}

let keepTwoDecimalFull = vlaue=> {
var result = parseFloat(vlaue);
if (isNaN(result)) {
alert('传递参数错误，请检查！');
return false;
}
result = Math.round(vlaue * 100) / 100;
var s_x = result.toString();
var pos_decimal = s_x.indexOf('.');
if (pos_decimal < 0) {
pos_decimal = s_x.length;
s_x += '.';
}
while (s_x.length <= pos_decimal + 2) {
s_x += '0';
}
return s_x;
}
export { dateformat,faultRepair_orderState,faultRepair_orderState_Class,moneyFormat,keepTwoDecimalFull }


// WEBPACK FOOTER //
// ./src/assets/js/utils/filters.js